import React from 'react';
import InfoPageShell from './InfoPageShell';

function LegalSection({ title, children }) {
  return (
    <section className="mb-8 sm:mb-10">
      <h2 className="font-semibold text-lg sm:text-xl text-white mb-3">{title}</h2>
      <div className="space-y-3 text-sm sm:text-base text-white/60 leading-relaxed">{children}</div>
    </section>
  );
}

function LegalDocument({ title, subtitle, lastUpdated, children }) {
  return (
    <InfoPageShell>
      <article className="bg-gradient-to-br from-dark-card/90 to-dark-surface/80 border border-dark-border rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 shadow-xl">
        <header className="mb-8 pb-6 border-b border-dark-border">
          <p className="text-xs font-medium uppercase tracking-wider text-white/40 mb-2">Legal</p>
          <h1 className="font-semibold text-2xl sm:text-3xl lg:text-4xl text-white mb-2">{title}</h1>
          {subtitle && <p className="text-sm sm:text-base text-white/50">{subtitle}</p>}
          {lastUpdated && (
            <p className="text-xs text-white/35 mt-4">Last updated: {lastUpdated}</p>
          )}
        </header>
        {children}
      </article>
    </InfoPageShell>
  );
}

export { LegalDocument, LegalSection };
